import { CheckCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { LoginFormLayout } from "../../../layouts/LoginFormLayout/LoginFormLayout";

import classes from "./VerificationCSP.module.css";

export function VerificationCSP(): ReactElement {
  const navigate = useNavigate();

  return (
    <LoginFormLayout
      name="Верификация прошла успешно"
      showSupportText={false}
      className={`${classes.content}`}
      childrenContainerClassName={`${classes.content__container}`}
    >
      <CheckCircleOutlined className={classes.content__icon} />

      <Button
        onClick={() => navigate("/login")}
        variant="solid"
        size="large"
        color="primary"
        className={classes.content__linkButton}
      >
        Перейти на сайт
      </Button>
    </LoginFormLayout>
  );
}
